import React from "react";
import { useLocation, Link } from "react-router-dom";
import DefaultData from "../CompanyData/DefaultData";
// The same features array from your LoginPage for consistency
const features = [
    { icon: 'ri-flight-takeoff-line', name: 'Flights' }, 
    { icon: 'ri-building-line', name: 'Hotels' },
    { icon: 'ri-car-line', name: 'Cars' }, 
    { icon: 'ri-bus-2-line', name: 'Bus' },
    { icon: 'ri-suitcase-line', name: 'Holidays' }, 
    { icon: 'ri-visa-line', name: 'Visas' },
    { icon: 'ri-magic-line', name: 'AI Packages' }, 
    { icon: 'ri-whatsapp-line', name: 'AI Chatbot' },
    { icon: 'ri-user-add-line', name: 'Leads' }, 
    { icon: 'ri-global-line', name: 'Website' },
    { icon: 'ri-bar-chart-line', name: 'Analytics' }, 
    { icon: 'ri-calculator-line', name: 'Accounting' }, // Added Smart Accounting
    { icon: 'ri-customer-service-2-line', name: 'Support' },
];

// Reusable left-side marketing component
const MarketingSide = () => (
  <div className="col-lg-7 text-center text-lg-start mb-5 mb-lg-0">
    <h1 className="display-6 fw-bolder mb-3" style={{ color: DefaultData.THEMECOLOR3 }}>{DefaultData.LANDINGPAGETITLE}</h1>
    <p className="fs-5 mb-5" style={{ color: DefaultData.THEMECOLOR3, opacity: 0.9 }}>{DefaultData.LANDINGPAGESUBTITLE}</p>
     <div className="row row-cols-3 row-cols-md-4 row-cols-lg-5 justify-content-center g-4">
                                {features.map((feature) => (
                                    <div className="col" key={feature.name}>
                                        <div className="text-center">
                                            <div 
                                                className="shadow-sm"
                                                style={{ 
                                                    width: '70px', 
                                                    height: '70px', 
                                                    borderRadius: '50%', 
                                                    backgroundColor: DefaultData.THEMECOLOR3, 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    justifyContent: 'center', 
                                                    color: DefaultData.THEMECOLOR2, // Changed to ThemeColor1 for contrast inside white circle 
                                                    marginBottom: '0.5rem', 
                                                    margin: '0 auto' 
                                                }}
                                            >
                                                <i className={`${feature.icon} fs-2`}></i>
                                            </div>
                                            <span className="fw-medium" style={{ color: DefaultData.THEMECOLOR3 }}>{feature.name}</span>
                                        </div>
                                        </div>
                                ))}
                            </div>
  </div>
);



export default function RegistrationPending() {
  const location = useLocation();
  const userEmail = location.state?.userEmail;

  return (
    <div style={{ backgroundColor: DefaultData.THEMECOLOR1 }}>
      <main className="container-fluid d-flex align-items-center" style={{ minHeight: '100vh' }}>
        <div className="container">
          <div className="row align-items-center justify-content-center">

            <MarketingSide />

            <div className="col-lg-5 d-flex justify-content-center justify-content-lg-end">
              <div className="card shadow-lg border-0" style={{ borderRadius: '1rem', width: '100%', maxWidth: '450px' }}>
                <div className="card-body p-lg-5 p-4 text-center">

                  <div className="mb-4 text-success">
                    <i className="ri-mail-check-fill" style={{ fontSize: '64px' }}></i>
                  </div>
                  <h4 className="fw-bold">Almost There!</h4>
                  <p className="text-muted">
                    We've sent a verification link to your email address: <strong>{userEmail || "your email"}</strong>.
                  </p>
                  <p className="text-muted mt-3">
                    Please check your inbox (and spam folder) and click the link to activate your account.
                  </p>
                  <div className="mt-4">
                    <Link to="/" className="btn w-100 fw-bold" style={{ backgroundColor: DefaultData.THEMECOLOR1, color: DefaultData.THEMECOLOR4 }}>
                      Return to Sign In
                    </Link>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}